import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=224a82d4&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=224a82d4&lang=css"
import style1 from "./ResourceDetail.vue?vue&type=style&index=1&id=224a82d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a82d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224a82d4')) {
      api.createRecord('224a82d4', component.options)
    } else {
      api.reload('224a82d4', component.options)
    }
    module.hot.accept("./ResourceDetail.vue?vue&type=template&id=224a82d4&scoped=true", function () {
      api.rerender('224a82d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/info/ResourceDetail.vue"
export default component.exports